export default "__VITE_ASSET__BxO3D8dM__"